import React from 'react'

/**
 * Displays the corresponding deduction rule where items and production rules
 * can be dropped.
 */
export function TagEarleyScanTerm() {
    return (<div className='deduction-rule'>
        <div className='rule-name'>ScanTerm:</div>
        <div className='middle-rule-part'>
            <div
                className='antecedence'><span className={'unbreakable'}>[γ, dot, la, i, j, k, l, 0]</span>
            </div>
            <hr/>
            <div
                className='consequence'><span className={'unbreakable'}>[γ, dot, ra, i, j, k, l + 1, 0]</span>
            </div>
        </div>
        <div className='side-condition'><span className={'unbreakable'}>l(γ, dot) = w<sub>l+1</sub></span></div>
    </div>)
}
